import { useEffect, useState } from 'react';
import CourseChapter from 'src/model/CourseChapter';
import CourseChapterRetriever from 'src/retriever/CourseChapterRetriever';

export default function useListCourseChapter(
  setError: (isError: boolean) => void,
  courseId?: string,
): Array<CourseChapter> {
  const [courseChaptersState, setCourseChapters] = useState([] as Array<CourseChapter>);
  useEffect(() => {
    CourseChapterRetriever.listCourseChapter(courseId)
      .then((courseChapters) => {
        setCourseChapters(courseChapters);
      })
      .catch(() => {
        setError(true);
      });
  }, []);
  return courseChaptersState;
}
